export const OnBoarding = {
    SET_ORDER_DETAILS:"SET_ORDER_DETAILS",
    SET_UPDATED_DETAILS:"SET_UPDATED_DETAILS",
    SET_UNIQUE_REF_NO:"SET_UNIQUE_REF_NO",
    SET_RBL_UNIQUE_REF_NO:"SET_RBL_UNIQUE_REF_NO",
    SET_CURRENT_STATE:"SET_CURRENT_STATE",
    SET_PREVIOUS_STATE:"SET_PREVIOUS_STATE",
    RESET: "RESET",
  }; 